import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { useLang } from '../../contexts/LangContext';
import AvatarUpload from '../../components/AvatarUpload';
import AlunaTabBar from '../../components/AlunaTabBar';
import PasswordInput from '../../components/PasswordInput';
import AvaliacaoTimelineAluna from '../../components/AvaliacaoTimelineAluna';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';

const s = {
  page: { minHeight: '100vh', background: '#f3eee7', padding: '26px 14px 40px', fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Inter', sans-serif" },
  nav: { width: 'min(100%, 430px)', margin: '0 auto', background: '#fffaf4', borderRadius: '44px 44px 0 0', padding: '28px 22px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 50, boxShadow: '0 0 0 1px rgba(255,255,255,.72), 0 28px 80px rgba(66,44,38,.10)' },
  navLogo: { fontFamily: "'Inter', sans-serif", fontSize: '16px', fontWeight: 900, color: 'var(--text)' },
  navLogoSpan: { color: 'var(--accent)' },
  backBtn: { height: '42px', padding: '0 14px', background: 'rgba(255,255,255,.54)', border: '1px solid rgba(216,202,182,.86)', color: '#7f7165', borderRadius: '999px', fontSize: '13px', cursor: 'pointer' },
  content: { width: 'min(100%, 430px)', minHeight: 'calc(100vh - 56px)', margin: '0 auto', padding: '24px 22px 118px', background: '#fffaf4', borderRadius: '0 0 44px 44px', boxShadow: '0 28px 80px rgba(66,44,38,.10), inset 0 -1px 0 rgba(255,255,255,.95)' },
  avatarWrap: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '24px', background: 'rgba(255,255,255,.78)', border: '1px solid rgba(255,255,255,.72)', borderRadius: '30px', padding: '22px', boxShadow: '0 14px 34px rgba(82,69,57,.07)' },
  avatar: { width: '88px', height: '88px', borderRadius: '50%', background: 'var(--text)', border: '2px solid var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Inter', sans-serif", fontSize: '32px', fontWeight: 700, color: '#FAF7F2', marginBottom: '12px' },
  avatarName: { fontSize: '20px', fontWeight: 600, color: '#251c19', letterSpacing: 0 },
  avatarRole: { fontSize: '12px', color: '#8c7f70', marginTop: '4px' },
  card: { background: 'rgba(255,255,255,.78)', border: '1px solid rgba(255,255,255,.72)', borderRadius: '28px', padding: '18px', marginBottom: '14px', boxShadow: '0 12px 28px rgba(82,69,57,.055), inset 0 1px 0 rgba(255,255,255,.84)' },
  cardTitle: { fontSize: '11px', fontWeight: 600, letterSpacing: '.09em', textTransform: 'uppercase', color: '#895b40', marginBottom: '16px' },
  row: { display: 'grid', gridTemplateColumns: '1fr', gap: '0' },
  label: { display: 'block', fontSize: '11px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#8c7f70', marginBottom: '6px' },
  input: { width: '100%', padding: '12px 14px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '18px', fontSize: '14px', color: '#251c19', background: '#f4eee6', outline: 'none' },
  select: { width: '100%', padding: '12px 14px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '18px', fontSize: '14px', color: '#251c19', background: '#f4eee6', outline: 'none' },
  textarea: { width: '100%', padding: '12px 14px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '18px', fontSize: '14px', color: '#251c19', background: '#f4eee6', outline: 'none', resize: 'vertical', minHeight: '72px' },
  field: { marginBottom: '16px' },
  submitBtn: { width: '100%', padding: '13px', background: '#251c19', color: '#fff9f2', border: 'none', borderRadius: '999px', fontSize: '13px', fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', cursor: 'pointer', marginTop: '8px' },
  success: { padding: '12px 16px', background: 'rgba(76,175,80,0.08)', border: '1px solid rgba(76,175,80,0.3)', color: '#2E7D32', borderRadius: 'var(--r-btn)', fontSize: '13px', marginBottom: '20px' },
  readValue: { padding: '12px 14px', border: '1px solid rgba(151,142,134,.16)', borderRadius: '18px', fontSize: '14px', color: '#251c19', background: '#f4eee6', minHeight: '18px' },
  readNote: { fontSize: '12px', color: '#8c7f70', marginBottom: '16px', lineHeight: 1.6 },
};

const MODALIDADES = {
  'nutricao-treino': 'Nutrição + Treino',
  treino: 'Treino',
  nutricao: 'Nutrição',
  bonus: 'Bônus',
  online: 'Consultoria Online (Treino + Nutrição)',
  'online-treino': 'Consultoria Online (Treino)',
  presencial: 'Treino Presencial',
};
const MODALIDADES_EN = {
  'nutricao-treino': 'Nutrition + Training',
  treino: 'Training',
  nutricao: 'Nutrition',
  bonus: 'Bonus',
  online: 'Online Consulting (Workout + Nutrition)',
  'online-treino': 'Online Consulting (Workout)',
  presencial: 'In-person Training',
};

function Campo({ label, valor }) {
  return (
    <div style={s.field}>
      <label style={s.label}>{label}</label>
      <div style={s.readValue}>{valor || '—'}</div>
    </div>
  );
}

export default function AlunaPerfil() {
  const { user, logout } = useAuth();
  const { lang, setLang } = useLang();
  const [senhaForm, setSenhaForm] = useState({ atual:'', nova:'', confirmar:'' });
  const [senhaMsg, setSenhaMsg] = useState(null);
  const [senhaSaving, setSenhaSaving] = useState(false);

  async function handleSenha(e) {
    e.preventDefault();
    if (senhaForm.nova !== senhaForm.confirmar) { setSenhaMsg({ type:'error', text: lang==='pt' ? 'As senhas não coincidem.' : 'Passwords do not match.' }); return; }
    if (senhaForm.nova.length < 6) { setSenhaMsg({ type:'error', text: lang==='pt' ? 'A senha deve ter pelo menos 6 caracteres.' : 'Password must be at least 6 characters.' }); return; }
    setSenhaSaving(true);
    const { error } = await supabase.auth.updateUser({ password: senhaForm.nova });
    if (error) {
      setSenhaMsg({ type:'error', text: error.message });
    } else {
      setSenhaMsg({ type:'success', text: lang==='pt' ? 'Senha atualizada com sucesso!' : 'Password updated successfully!' });
      setSenhaForm({ atual:'', nova:'', confirmar:'' });
    }
    setSenhaSaving(false);
  }
  const { perfis } = useData();
  const navigate = useNavigate();
  const perfil = perfis[user?.id] || {};
  const copy = {
    evolucao: lang === 'pt' ? 'Minha evolução' : 'My progress',
    avaliacao: lang === 'pt' ? 'Avaliação física' : 'Physical assessment',
    readNote: lang === 'pt' ? 'A equipe mantém estes dados atualizados. Se algum campo estiver vazio ou tiver mudado, envie uma mensagem pelo chat.' : 'The team keeps these details updated. If a field is empty or has changed, send us a message in chat.',
    dados: lang === 'pt' ? 'Dados pessoais' : 'Personal details',
    telefone: lang === 'pt' ? 'WhatsApp' : 'WhatsApp',
    nascimento: lang === 'pt' ? 'Data de nascimento' : 'Date of birth',
    cidade: lang === 'pt' ? 'Cidade' : 'City',
    pais: lang === 'pt' ? 'País' : 'Country',
    altura: lang === 'pt' ? 'Altura' : 'Height',
    modalidade: lang === 'pt' ? 'Modalidade contratada' : 'Plan type',
    treinoAval: lang === 'pt' ? 'Avaliações de Treino' : 'Workout assessments',
    nutriAval: lang === 'pt' ? 'Avaliações de Nutrição' : 'Nutrition assessments',
    aluno: lang === 'pt' ? 'Aluno' : 'Student',
    aluna: lang === 'pt' ? 'Aluna' : 'Student',
    voltar: lang === 'pt' ? 'Voltar' : 'Back',
  };
  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <img src="/logo.svg" alt="Team Carol Macedo" style={{ height:'30px', width:'auto', objectFit:'contain' }} />
        <button style={s.backBtn} onClick={() => navigate('/aluna')}>{copy.voltar}</button>
      </nav>

      <div style={s.content}>
        <div style={s.avatarWrap}>
          <AvatarUpload userId={user?.id} nome={user?.name} size={88} />
          <div style={{ ...s.avatarName, marginTop: '12px' }}>{user?.name}</div>
          <div style={s.avatarRole}>{user?.genero === 'aluno' ? copy.aluno : copy.aluna}</div>
        </div>

        <div className="list" style={{ marginBottom: '24px' }}>
          <button className="list-item" onClick={() => navigate('/aluna/evolucao')}>
            <span className="list-icon">
              <svg viewBox="0 0 24 24"><path d="M3 3v18h18" /><path d="M7 15l4-4 3 3 5-6" /></svg>
            </span>
            <span className="title">{copy.evolucao}</span>
            <span className="chev"><svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6" /></svg></span>
          </button>
          <button className="list-item" onClick={() => navigate('/aluna/agendar')}>
            <span className="list-icon">
              <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="3" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
            </span>
            <span className="title">{copy.avaliacao}</span>
            <span className="chev"><svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6" /></svg></span>
          </button>
        </div>

        <div style={{ marginBottom:16 }}>
          <p style={{ ...s.readNote, marginBottom:8 }}>{copy.readNote}</p>
          <button type="button" onClick={() => navigate('/aluna/chat')} style={{ padding:'9px 14px', border:'1px solid rgba(137,91,64,.2)', borderRadius:999, background:'rgba(255,255,255,.7)', color:'#895b40', fontSize:12, fontWeight:650, cursor:'pointer' }}>
            {lang==='pt'?'Pedir atualização no chat →':'Request an update in chat →'}
          </button>
        </div>

        <div>
          <div style={s.card}>
            <div style={s.cardTitle}>{copy.dados}</div>
            <div style={s.row}>
              <Campo label={copy.telefone} valor={perfil.telefone} />
              <Campo label={copy.nascimento} valor={perfil.dataNascimento} />
            </div>
            <div style={s.row}>
              <Campo label={copy.cidade} valor={perfil.cidade} />
              <Campo label={copy.pais} valor={perfil.pais} />
            </div>
            <div style={s.row}>
              <Campo label={copy.altura} valor={perfil.altura} />
              <Campo label={copy.modalidade} valor={(lang === 'pt' ? MODALIDADES : MODALIDADES_EN)[perfil.modalidade] || perfil.modalidade} />
            </div>
          </div>

          <AvaliacaoTimelineAluna tabela="avaliacoes_treino" alunaId={user?.id} titulo={copy.treinoAval} />
          <AvaliacaoTimelineAluna tabela="avaliacoes_nutricao" alunaId={user?.id} titulo={copy.nutriAval} />
        </div>

        {/* Seletor de idioma */}
      <div style={s.card}>
        <div style={s.cardTitle}>{lang==='pt' ? 'Idioma' : 'Language'}</div>
        <div style={{ display:'flex', gap:'8px' }}>
          {[['pt','🇧🇷 Português'],['en','🇺🇸 English']].map(([l, label]) => (
            <button key={l} onClick={() => setLang(l)} style={{ flex:1, padding:'11px 10px', border:`1px solid ${lang===l ? '#251c19' : 'rgba(216,202,182,.86)'}`, borderRadius:'999px', background: lang===l ? '#251c19' : 'rgba(255,255,255,.44)', color: lang===l ? '#fff9f2' : '#7f7165', fontSize:'13px', cursor:'pointer', fontFamily:"-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Inter',sans-serif", fontWeight: lang===l ? 600 : 500 }}>{label}</button>
          ))}
        </div>
      </div>

      {/* Redefinir senha */}
      <div style={s.card}>
        <div style={s.cardTitle}>{lang==='pt' ? 'Redefinir senha' : 'Change password'}</div>
        <form onSubmit={handleSenha}>
          {['nova','confirmar'].map(field => (
            <div key={field} style={{ marginBottom:'10px' }}>
              <label style={s.label}>
                {field === 'nova' ? (lang==='pt' ? 'Nova senha' : 'New password') : (lang==='pt' ? 'Confirmar senha' : 'Confirm password')}
              </label>
              <PasswordInput
                value={senhaForm[field]}
                onChange={e => setSenhaForm(f => ({...f, [field]: e.target.value}))}
                style={s.input}
                placeholder={field === 'nova' ? (lang==='pt' ? 'Mínimo 6 caracteres' : 'Minimum 6 characters') : (lang==='pt' ? 'Repita a nova senha' : 'Repeat new password')}
                showLabel={lang === 'pt' ? 'Mostrar senha' : 'Show password'}
                hideLabel={lang === 'pt' ? 'Ocultar senha' : 'Hide password'}
              />
            </div>
          ))}
          {senhaMsg && (
            <div style={{ padding:'10px 12px', borderRadius:'18px', fontSize:'12px', marginBottom:'10px', background: senhaMsg.type==='error' ? 'rgba(229,57,53,0.07)' : 'rgba(76,175,80,0.07)', color: senhaMsg.type==='error' ? '#C62828' : '#2E7D32', border:`1px solid ${senhaMsg.type==='error' ? 'rgba(229,57,53,0.2)' : 'rgba(76,175,80,0.2)'}` }}>
              {senhaMsg.text}
            </div>
          )}
          <button type="submit" disabled={senhaSaving || !senhaForm.nova || !senhaForm.confirmar} style={{ ...s.submitBtn, background: senhaForm.nova && senhaForm.confirmar ? '#251c19' : 'rgba(37,28,25,0.12)', color: senhaForm.nova && senhaForm.confirmar ? '#fff9f2' : '#8c7f70', cursor: senhaForm.nova ? 'pointer' : 'not-allowed' }}>
            {senhaSaving ? (lang==='pt' ? 'Salvando...' : 'Saving...') : (lang==='pt' ? 'Atualizar senha' : 'Update password')}
          </button>
        </form>
      </div>

      <button type="button" onClick={handleLogout} style={{ width:'100%', padding:'13px', background:'rgba(137,91,64,.08)', color:'#895b40', border:'1px solid rgba(137,91,64,.18)', borderRadius:'999px', fontSize:'13px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', cursor:'pointer' }}>
        {lang === 'pt' ? 'Sair da conta' : 'Sign out'}
      </button>

      </div>
      <AlunaTabBar current="perfil" />
    </div>
  );
}
